import axios from "axios";
import { Base_URL } from "../url";

export const fetchBalanceAdjustmentData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/BalanceAdjustmentAdvanceReq/BalanceGetApi`);
    console.log("API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("API Fetch Error:", error);
    throw error.response?.data || "Failed to fetch balance adjustment data";
  }
};